import { handleResponse } from "utils/utils";
import { authService } from "services";

export const providersService = {
    getAll,
    getById,
    add,
    update,
    remove,
};

// get providers
function getAll(options) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`
        },
    };

    let query = '?sort=+name';

    if (options) {
        let { q } = options;

        if (q !== undefined)
            query += "&q=" + q;
    }

    return fetch(`${global.BASE_API}providers${query}`, requestOptions).then(handleResponse);
}

// get provider by id
function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`
        },
    };

    return fetch(`${global.BASE_API}providers/${id}`, requestOptions).then(handleResponse);
}

// add new provider
function add(provider) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(provider)
    };

    return fetch(`${global.BASE_API}providers/`, requestOptions).then(handleResponse);
}

// update provider
function update(provider) {
    const requestOptions = {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(provider)
    };

    return fetch(`${global.BASE_API}providers/${provider.id}`, requestOptions).then(handleResponse);
}

// remove provider
function remove(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`
        },
    };

    return fetch(`${global.BASE_API}providers/${id}`, requestOptions).then(handleResponse);
}
